import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const HighSchool = () => {
    const [id, setID] = useState("");
    const [name, setName] = useState("");
    const [birth, setBirth] = useState("");
    const [specialize, setSpecialize] = useState(0);
    const [english, setEnglish] = useState(0);
    const [math, setMath] = useState(0);
    const [literature, setLiterature] = useState(0);
    const [isGetPoint, setIsGetPoint] = useState(false);
    const navigate = useNavigate();

    const getResult = async (e) => {
        e.preventDefault();
        setIsGetPoint(false);
        const time = toast.loading("Vui lòng chờ...");
        const searchUrl = `https://admission-result.somee.com/api/Crawl/highschool?name=${name}&sbd=${id}&birth=${birth}`;
        await axios.get(searchUrl).then((response) => {
            const result = response.data;
            if (result?.status && result?.data && result?.data?.data) {
                const subjectScores = result?.data?.data?.subjectScores;
                setSpecialize(subjectScores?.Chuyen?.point);
                setEnglish(subjectScores?.NgoaiNgu?.point);
                setMath(subjectScores?.Toan?.point);
                setLiterature(subjectScores?.Van?.point);
                setIsGetPoint(true);
                toast.update(time, { render: "Đã xong", type: "success", isLoading: false, autoClose: 2000 });
            }
            else {
                toast.update(time, { render: "Không có dữ liệu", type: "error", isLoading: false, autoClose: 2000 });
            }
        }).catch((error) => {
            toast.update(time, { render: "Lỗi", type: "error", isLoading: false, autoClose: 2000 });
        });
    }

    return (
        <div className="container">
            <br />
            <h2>
                Tra Cứu Điểm Thi lớp 10 năm 2024
            </h2>

            <form className="was-validated" onSubmit={getResult}>
                <div className="form-group">
                    <label htmlFor="point" className="mb-1">Số Báo Danh:</label>
                    <br />
                    <input
                        type="text"
                        className="form-control"
                        id="point"
                        placeholder="Nhập số báo danh"
                        name="point"
                        value={id}
                        onChange={e => setID(e.target.value)}
                        required={!id || id === ""} />
                    <div className="valid-feedback">Hợp lệ</div>
                    <div className="invalid-feedback">Vui lòng nhập đầy đủ</div>
                </div>
                <div className="form-group">
                    <label htmlFor="name" className="mb-1">Họ và tên:</label>
                    <br />
                    <input
                        type="text"
                        className="form-control"
                        id="name"
                        placeholder="Nhập họ tên"
                        name="name"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        required={!name || name === ""} />
                    <div className="valid-feedback">Hợp lệ</div>
                    <div className="invalid-feedback">Vui lòng nhập đầy đủ</div>
                </div>
                <div className="form-group">
                    <label htmlFor="birth" className="mb-1">Ngày sinh: *Nhập tháng + ngày + năm ghi liền không dấu</label>
                    <br />
                    <input
                        type="text"
                        className="form-control"
                        id="birth"
                        placeholder="Nhập ngày sinh"
                        name="birth"
                        value={birth}
                        onChange={e => setBirth(e.target.value)}
                        required={!birth || birth === ""} />
                    <div className="valid-feedback">Hợp lệ</div>
                    <div className="invalid-feedback">Vui lòng nhập đầy đủ</div>
                </div>
                <br />
                <button type="submit" className="btn btn-primary">Tra cứu điểm thi</button>
            </form>
            <br />
            <br />
            {
                isGetPoint &&
                <>
                    <h2 className="mb-5">
                        Kết Quả Tra Cứu Điểm Thi Lớp 10
                    </h2>

                    <div className="resultSearch__left">
                        <div className="resultSearch__left-sbd">
                            <p>Số báo danh</p>
                            <p className="font-bold">{id}</p>
                        </div>
                        <div className="resultSearch__left-info">
                            <p className="edu-institution">Sở GD&amp;ĐT Thành Phố Hồ Chí Minh</p>

                            <div className="controll__box share-link">
                                <a className="newFeature__iconLink" title="Chia sẻ bài viết lên facebook" titleshare="Chi tiết điểm thi tốt nghiệp THPT" type="facebook" href="javascript:;">
                                    <span className="img img-facebook"></span>
                                </a>
                                <a className="newFeature__iconLink" title="Chia sẻ bài viết lên twitter" titleshare="Chi tiết điểm thi tốt nghiệp THPT" type="twitter" href="javascript:;">
                                    <span className="img img-twitter"></span>
                                </a>
                                <a className="newFeature__iconLink" title="Chia sẻ bài viết lên email" titleshare="Chi tiết điểm thi tốt nghiệp THPT" type="email" href="javascript:;">
                                    <span className="img img-email"></span>
                                </a>
                                <a className="newFeature__iconLink tooltip" href="#share" type="copy" titleshare="Chi tiết điểm thi tốt nghiệp THPT" title="Sao chép liên kết">
                                    <span className="tooltiptext" id="myTooltip">Sao chép liên kết</span>
                                    <span className="img img-share"></span>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="resultSearch__right">
                        <table>
                            <thead>
                                <tr>
                                    <th>Môn</th>
                                    <th>Điểm</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Toán</td>
                                    <td>{math}</td>
                                </tr>
                                <tr>
                                    <td>Văn</td>
                                    <td>{literature}</td>
                                </tr>
                                <tr>
                                    <td>Ngoại ngữ</td>
                                    <td>{english}</td>
                                </tr>
                                <tr>
                                    <td>Chuyên</td>
                                    <td>{specialize}</td>
                                </tr>
                                <tr>
                                    <td><b>Tổng điểm</b></td>
                                    <td><b>{specialize + math + literature + english}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </>
            }
            <br />
            <br />
            <div className="d-flex flex-row justify-content-around">
                <a href="https://zalo.me/g/xxpwxr794"><img src={require("../../assets/images/2.jpg")} alt="zaloGroup" width="300" height="200" /></a>
                <a href="https://www.viendong.edu.vn/huong-dan-lam-thu-tuc-nhap-hoc-danh-cho-thi-sinh-2024.html"><img src={require("../../assets/images/1.jpg")} alt="Cao đẳng Viễn Đông" width="300" height="200" /></a>
            </div>
        </div>
    )
}

export default HighSchool;